import { connectRouter } from 'connected-react-router';
import * as reducers from 'exacta-material-react/lib/src/store/reducers';

import history from '../../helpers/history';
import executor from './executor.reducer';
import resources from './resources.reducer';

const rootReducer = {
  ...reducers,
  executor,
  resources,
  router: connectRouter(history),
};

export default rootReducer;
